import SubsectionHeaderContent from "./SubsectionHeaderContent";

export default SubsectionHeaderContent;
export { SubsectionHeaderContent };
